export * from '@primeuix/themes/aura/scrollpanel';
export { default } from '@primeuix/themes/aura/scrollpanel';
